const initialState = {
    isReReg: false,
  };
  
const isReRegReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_IS_RE_REG":
      return { ...state, isReReg: action.payload };
    case "SET_PMC_RE_REG_SOFT_LAUNCH":
      return { ...state, pmcReregData: action.payload };
    default:
      return state;
  }
};
  
  export default isReRegReducer;
  